<template>
  <div class="tab" v-show="isActive">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'Tab',
  props: {
    title: {
      type: String,
      default: 'Tab',
    },
  },
  data: () => ({
    isActive: false,
  }),
};
</script>

<style lang="scss" scoped>
.tab {
  @apply flex flex-1;
}
</style>
